module.exports = __webpack_public_path__ + "static/media/CloudCardsApp.c42caa5e.JPG";